export default __webpack_public_path__ + "static/media/icons8-report-card.82d2f553.svg";